import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Stack,
} from '@mui/material';
import {
  Email,
  Launch,
  Business,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Open in new tab after a short delay to show the message
    const timer = setTimeout(() => {
      window.open('https://kief.studio/contactus', '_blank', 'noopener,noreferrer');
      // Navigate back to home after opening the new tab
      setTimeout(() => {
        navigate('/');
      }, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center',
      py: { xs: 8, md: 12 } 
    }}>
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 3,
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Email sx={{ fontSize: 40, color: 'white' }} />
            </Box>

            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Opening Kief Studio Contact
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
              Opening our parent company's contact page in a new tab. 
              Kief Studio handles all inquiries for PWGen-Rust.
            </Typography>

            <CircularProgress size={40} />

            <Stack spacing={2} sx={{ width: '100%', mt: 2 }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<Launch />}
                href="https://kief.studio/contactus"
                target="_blank"
                rel="noopener noreferrer"
                fullWidth
                sx={{ py: 1.5 }}
              >
                Go to Kief Studio Contact
              </Button>

              <Button
                variant="outlined"
                size="large"
                startIcon={<Business />}
                onClick={() => navigate('/')}
                fullWidth
                sx={{ py: 1.5 }}
              >
                Return to Home
              </Button>
            </Stack>

            <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
              If the page doesn't open automatically, please click the button above.
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPage;